import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import { Tooltip } from "react-tooltip";
import indiaGeo from "../../../../../other/json/india.topo.json";
import { geoCentroid } from "d3-geo";
import React, { useEffect, useState } from "react";

const StateInfoMap = (props) => {
  const [statesInfo, setStatesInfo] = useState({});
  const [stateData, setstateData] = useState([]);
  const [timeline, setTimeline] = useState("TODAY");

  const mapColumns = [
    {
      dataIndex: "state",
      title: "State",
      render: (text) => {
        return <span className="table-primary-text">{text}</span>;
      },
    },
    {
      dataIndex: "totalDigiRep",
      title: "# Digirep",
    },
    {
      dataIndex: "activeDigiRep",
      title: "# Active Digirep",
    },
    {
      dataIndex: "totalLeads",
      title: "# Leads",
    },
    {
      dataIndex: "totalDisbursementAmount",
      title: "# Disbursed Amt.",
      render: (text) => {
        return <>₹ {text?.cur(0)}</>;
      },
    },
  ];

  const getStateMetrics = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }

    props.apis.apiGetStateMetrics(data, payload).then((res) => {
      console.log({ res });
      setstateData(res);
      const stateStats = res.reduce((acc, item) => {
        acc[item.state] = {
          state: item.state,
          totalDigiRep: item.totalDigiRep,
          activeDigiRep: item.activeDigiRep,
          totalLeads: item.totalLeads,
          totalDisbursementAmount: `₹${item.totalDisbursementAmount}`,
        };
        return acc;
      }, {});

      setStatesInfo(stateStats);
    });
  };

  useEffect(() => {
    getStateMetrics();
  }, []);

  return (
    <div className="row mt-4 mx-auto">
      <div className="col-12 col-md-12 col-lg-6 state_map_container">
        <div className="position-relative">
          {/* Shadow Layer */}
          <ComposableMap
            projection="geoMercator"
            projectionConfig={{
              scale: 1000,
              center: [82.8, 22.59],
            }}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              filter: "blur(3px)",
              transform: "translateY(20px) scale(0.98)",
              zIndex: 0,
              pointerEvents: "none",
              width: "100%",
              height: "500px",
            }}
          >
            <Geographies geography={indiaGeo}>
              {({ geographies }) =>
                geographies.map((geo) => (
                  <Geography
                    key={`shadow-${geo.rsmKey}`}
                    geography={geo}
                    fill="black"
                    stroke="none"
                    style={{
                      default: {
                        fill: "black",
                        opacity: 0.15,
                        outline: "none",
                      },
                    }}
                  />
                ))
              }
            </Geographies>
          </ComposableMap>

          <ComposableMap
            projection="geoMercator"
            projectionConfig={{
              scale: 1000,
              center: [82.8, 22.59],
            }}
            style={{
              width: "100%",
              height: "500px",
              position: "relative",
              zIndex: 1,
            }}
          >
            <Geographies geography={indiaGeo}>
              {({ geographies }) =>
                geographies.map((geo) => {
                  const stateName = geo.properties.name;
                  // console.log({ stateName });

                  const data = statesInfo[stateName || ""];
                  const centroid = geoCentroid(geo);
                  if (data) {
                    console.log({ data });
                  }

                  return (
                    <React.Fragment key={geo.rsmKey}>
                      <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        style={{
                          default: {
                            fill: "#EEF0FF",
                            outline: "none",
                          },
                          hover: {
                            fill: "#120192",
                            outline: "none",
                            cursor: "pointer",
                          },
                          pressed: {
                            fill: "#120192",
                            outline: "none",
                          },
                        }}
                        data-tooltip-id="india-tooltip"
                        data-tooltip-html={
                          data
                            ? `
                            <table class="tooltip_table">
                              <tbody>
                                <tr>
                                  <td>State</td>
                                  <td>:</td>
                                  <td>
                                    <strong>${stateName}</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td># Total Digirep</td>
                                  <td>:</td>
                                  <td>
                                    <strong>${data.totalDigiRep}</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td># Active Digirep</td>
                                  <td>:</td>
                                  <td>
                                    <strong>${data.activeDigiRep}</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td># Total Leads</td>
                                  <td>:</td>
                                  <td>
                                    <strong>${data.totalLeads}</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td># Disbursed Amt.</td>
                                  <td>:</td>
                                  <td>
                                    <strong>${data.totalDisbursementAmount}</strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                  `
                            : `<strong>${stateName}</strong><br/>No Data`
                        }
                      />
                      {/* Add marker only if state has data */}
                      {data && (
                        <Marker coordinates={centroid}>
                          <image
                            href={imagepaths.blueLocationMarkerIcon}
                            width={14}
                            height={14}
                            {...(stateName === "Goa"
                              ? { x: "-8", y: "-6" }
                              : { x: "-12", y: "-6" })}
                            className="marker_img"
                          />
                        </Marker>
                      )}
                    </React.Fragment>
                  );
                })
              }
            </Geographies>
          </ComposableMap>

          <Tooltip id="india-tooltip" place="top" float />
        </div>
      </div>
      <div className="col-12 col-md-12 col-lg-6">
        <AppTable
          data={stateData}
          columns={mapColumns}
          showPagination={false}
          reorder={true}
          editable={false}
          viewable={false}
          deletable={false}
        ></AppTable>
      </div>
    </div>
  );
};
export default constore(StateInfoMap);
